import React from "react";
import "./Containers.css";

interface ContentContainerProps {
  showBackground?: boolean;
  children?: React.JSX.Element;
  showcase?: boolean;
  footer?: boolean;
}

function ContentContainer({
  showBackground = true,
  showcase = false,
  footer = false,
  children
}: ContentContainerProps) {
  return (
    <div
      className={`page-section${showcase ? " showcase-container" : ""}${footer ? " footer-container mt-auto" : ""}`}
    >
      <div className="container">
        <div className={`col${showBackground ? "" : " hide-background"}`}>
          {children ? children : null}
        </div>
      </div>
    </div>
  );
}

export default ContentContainer;
